var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.code)?_c('span',{staticClass:"e-flag-icon",class:_vm.flagCountryIcon}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }